import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";

import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

export default function Charitableactivities() {
    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(0);
    
    const openGallery = (images, currentIndex) => {
        setSlides(images.map((img) => ({ src: img })));
        setIndex(currentIndex);
        setOpen(true);
    };

    const galleryCharitable = [
    
    {
      title: "PEACE MARCH ON UKRAINE CRISIS",
      images: [
        "/img/gallery/peacemarch/1.jpg",
        "/img/gallery/peacemarch/2.jpg",
        "/img/gallery/peacemarch/3.jpg",
        "/img/gallery/peacemarch/4.jpg",
        "/img/gallery/peacemarch/5.jpg",
        "/img/gallery/peacemarch/6.jpg",
        "/img/gallery/peacemarch/7.jpg",
        "/img/gallery/peacemarch/8.jpg",
        "/img/gallery/peacemarch/9.jpg",
        "/img/gallery/peacemarch/10.jpg",
        "/img/gallery/peacemarch/11.jpg",
        "/img/gallery/peacemarch/12.jpg",
        "/img/gallery/peacemarch/13.jpg",
        "/img/gallery/peacemarch/14.jpg",
        "/img/gallery/peacemarch/15.jpg",
        "/img/gallery/peacemarch/16.jpg",
      ],
    },
    {
      title: "Gandhi Mandela Foundation’s Sanitation – a Sunday drive for a cleaner, greener tomorrow.",
      images: [
        "/img/gallery/charitable2/1.jpeg",
        "/img/gallery/charitable2/2.jpeg",
        "/img/gallery/charitable2/3.jpeg",
        "/img/gallery/charitable2/4.jpeg",
        "/img/gallery/charitable2/5.jpeg",
        "/img/gallery/charitable2/6.jpeg",
        "/img/gallery/charitable2/7.jpeg",
        "/img/gallery/charitable2/8.jpeg",
      ],
    },
    {
      title: "Gandhi Mandela Foundation’s Yog Sakha – a Sunday initiative for health, harmony & collective well-being.",
      images: [
        "/img/gallery/charitable3/1.jpeg",
        "/img/gallery/charitable3/2.jpeg",
        "/img/gallery/charitable3/3.jpeg",
        "/img/gallery/charitable3/4.jpeg",
        "/img/gallery/charitable3/5.jpeg",
        "/img/gallery/charitable3/6.jpeg",
        "/img/gallery/charitable3/7.jpeg",
      ],
    },
    {
      title: "Gandhi Mandela Foundation’s Yog Sakha – a Sunday initiative for health, harmony & collective well-being.",
      images: [
        "/img/gallery/charitable4/1.jpeg",
        "/img/gallery/charitable4/2.jpeg",
        "/img/gallery/charitable4/3.jpeg",
        "/img/gallery/charitable4/4.jpeg",
        "/img/gallery/charitable4/5.jpeg",
        "/img/gallery/charitable4/6.jpeg",
        "/img/gallery/charitable4/7.jpeg",
        "/img/gallery/charitable4/8.jpeg",
        "/img/gallery/charitable4/9.jpg",
        "/img/gallery/charitable4/10.jpg",
        "/img/gallery/charitable4/11.jpg",
        "/img/gallery/charitable4/12.jpg",
        "/img/gallery/charitable4/13.jpg",
        "/img/gallery/charitable4/14.jpg",
        "/img/gallery/charitable4/15.jpg",
        "/img/gallery/charitable4/16.jpg",
        "/img/gallery/charitable4/17.jpg",
        "/img/gallery/charitable4/18.jpg",
        "/img/gallery/charitable4/19.jpg",
        "/img/gallery/charitable4/20.jpg",
      ],
    },
    {
      title: "GMF Empowering Underprivileged Children through Character Building, Hands-on Skills, and Community-driven Teaching",
      images: [
        "/img/gallery/charitable5/1.jpg",
        "/img/gallery/charitable5/2.jpg",
        "/img/gallery/charitable5/3.jpg",
        "/img/gallery/charitable5/4.jpg",
        "/img/gallery/charitable5/5.jpg",
        "/img/gallery/charitable5/6.jpg",
        "/img/gallery/charitable5/7.jpg",
        "/img/gallery/charitable5/8.jpg",
        "/img/gallery/charitable5/9.jpg",
        "/img/gallery/charitable5/10.jpg",
      ],
    },
    {
      title: "GMF Supports players by helping them participate and perform in International and National Tournament",
      images: [
        "/img/gallery/charitable6/1.jpg",
        "/img/gallery/charitable6/2.jpg",
        "/img/gallery/charitable6/3.jpg",
      ],
    },
    {
      title: "Ration Distribution",
      images: [
        "/img/gallery/ration/1.png",
        "/img/gallery/ration/2.png",
        "/img/gallery/ration/3.png",
        "/img/gallery/ration/4.png",
        "/img/gallery/ration/5.png",
        "/img/gallery/ration/6.png",
      ],
    },
    {
      title: "CSR Activities",
      images: [
        "/img/gallery/CSR/1.jpg",
        "/img/gallery/CSR/2.jpg",
        "/img/gallery/CSR/3.jpg",
        "/img/gallery/CSR/4.jpg",
        "/img/gallery/CSR/5.jpg",
        "/img/gallery/CSR/6.jpg",
        "/img/gallery/CSR/7.jpg",
        "/img/gallery/CSR/8.jpg",
        "/img/gallery/CSR/9.jpg",
        "/img/gallery/CSR/10.jpg",
        "/img/gallery/CSR/11.jpg",
        "/img/gallery/CSR/12.jpg",
        "/img/gallery/CSR/13.jpg",
        "/img/gallery/CSR/14.jpg",
        "/img/gallery/CSR/15.jpg",
      ],
    },
];
  return (
    <>
      <Helmet>
        <title>Charitable Activities | Gandhi Mandela Foundation</title>
      </Helmet>

      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Charitable Activities</span>
          </div>

          <h1>Charitable Activities</h1>
        </div>
      </section>
        
      <section className="gallery-section">
        <div className="container">
        
          {galleryCharitable.map((section, sectionIndex) => (
            <div className="gallery-block" key={sectionIndex}>

              <h2 className="gallery-title">
                {section.title}
              </h2>
                {/* Sirf Yoga Day section me banner dikhega */}
                    {section.title === "Nelson Mandela Day" && (
                    <div
                        className="full-image-wrapper"
                        onClick={() =>
                            openGallery(
                            ["/img/gallery/GMF/1.jpg", ...section.images],
                            0
                            )
                        }
                        >
                        <img
                            src="/img/gallery/GMF/1.jpg"
                            alt="Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020"
                            className="full-width-image"
                        />
                        <h4 align="center">
                            Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020
                        </h4>
                    </div>
                    )}
              <div className="gallery-grid">

                {section.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-card"
                    onClick={() =>
                      openGallery(section.images, imageIndex)
                    }
                  >
                    <img
                      src={image}
                      alt={`${section.title} ${imageIndex + 1}`}
                    />
                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>
      </section>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Thumbnails, Counter]}
      />
      <Footer />
    </>
  );
}
